import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { d as defineCustomElement$2 } from './p-5475c333.js';

const biDrawerCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.drawer{position:fixed;border:none;z-index:1200;height:100vh;width:100vw;display:flex;transition:transform 0.3s ease-in-out;overflow-y:hidden}.drawer.left{justify-content:flex-start;align-items:center;transform:translateX(-100%)}.drawer.right{justify-content:flex-end;align-items:flex-end;transform:translateX(100%)}.drawer.top{justify-content:center;align-items:flex-start;transform:translateY(-100%)}.drawer.bottom{justify-content:center;align-items:flex-end;transform:translateY(100%)}.drawer.open{transform:translateX(0)}.modal-drawer-content{position:relative;z-index:1201;box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.5);border-radius:0}.modal-drawer-content.background-primary{background-color:var(--bi-primary-100);color:white}.modal-drawer-content.background-white{background-color:white}.modal-drawer-content.background-neutral{background-color:var(--bi-neutral-5)}.modal-drawer-content.right,.modal-drawer-content.left{max-width:632px;width:fit-content;height:100%}.modal-drawer-content.top,.modal-drawer-content.bottom{width:100%;max-width:100vw}";
const BiDrawerStyle0 = biDrawerCss;

const BiDrawer$1 = /*@__PURE__*/ proxyCustomElement(class BiDrawer extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.close = createEvent(this, "close", 7);
        /**
         * If true, clicking on the backdrop will not close the drawer.
         */
        this.disableBackdropClick = false;
        /**
         * The position of the drawer. Can be 'top', 'bottom', 'left', or 'right'.
         */
        this.position = 'right';
        /**
         * The background color of the drawer. Can be 'white' or 'blue-strong'.
         */
        this.backgroundColor = 'white';
        /** If true, the drawer is open. */
        this.isOpen = false;
    }
    render() {
        return (h(Host, { key: '75b9c3a7188d8485ac13cba8320e0f50e55661c9' }, h("base-modal", { key: '226b1009db67346062949aa8498e18754d5f4395', disableBackdropClick: this.disableBackdropClick, isOpen: this.isOpen, classes: classNames('drawer', this.position, { open: this.isOpen }) }, h("div", { key: 'ad391d02c88f91c7ea0eb41a7c692dadc7699508', class: classNames('modal-drawer-content', `background-${this.backgroundColor}`, `${this.position}`) }, h("slot", { key: '37f67c1601074e483417a42c40b46dad99c43877' })))));
    }
    static get style() { return BiDrawerStyle0; }
}, [1, "bi-drawer", {
        "disableBackdropClick": [516, "disable-backdrop-click"],
        "position": [1],
        "backgroundColor": [1, "background-color"],
        "isOpen": [516, "is-open"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-drawer", "base-modal"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-drawer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiDrawer$1);
            }
            break;
        case "base-modal":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BiDrawer = BiDrawer$1;
const defineCustomElement = defineCustomElement$1;

export { BiDrawer, defineCustomElement };
